import React from 'react';
import {NavLink, useLocation} from 'react-router-dom';

interface SubHeader {
  label: string;
  to: string;
  onClick: () => void;
}

interface NavbarHeaderProps {
  headerTitle: string;
  subHeaders: SubHeader[];
  onLinkClick: () => void;
  headerClassName?: string;
  subHeaderClassName?: string;
}

export default function NavbarHeader({
  headerTitle,
  subHeaders,
  onLinkClick,
  headerClassName,
  subHeaderClassName,
}: NavbarHeaderProps) {
  const location = useLocation();
  const isGroupActive = subHeaders.some(link => link.to === location.pathname);
  const finalHeaderClass = `${headerClassName || 'section-title'} ${isGroupActive ? 'group-active-header' : ''}`;

  return (
    <>
      <div className={finalHeaderClass}>{headerTitle}</div>

      {subHeaders.map(link => (
        <NavLink
          key={link.to}
          to={link.to}
          onClick={onLinkClick}
          className={({isActive}) =>
            `${subHeaderClassName || 'group-link'} ${isActive ? 'active-sub-link' : ''}`
          }>
          {link.label}
        </NavLink>
      ))}
    </>
  );
}
